// extracted by mini-css-extract-plugin
export var modalContainer = "ModalOverlay-module--modalContainer--230f7";
export var modalDecenterSpace = "ModalOverlay-module--modalDecenterSpace--bd1d6";
export var open = "ModalOverlay-module--open--aa27e";
export var overlay = "ModalOverlay-module--overlay--18629";
export var textStyleLargeTitle = "ModalOverlay-module--text-style-large-title--2e17a";
export var textStyleLargestTitle = "ModalOverlay-module--text-style-largest-title--25f82";
export var textStyleMediumTitle = "ModalOverlay-module--text-style-medium-title--a5eea";
export var textStyleSmallTitle = "ModalOverlay-module--text-style-small-title--a2d3a";
export var withNoVerticalPadding = "ModalOverlay-module--withNoVerticalPadding--1d03e";